import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
export const invitationInfoResponseSchema = z.object({
    workspaceName: z.string(),
});
export class InvitationInfoResponseDto extends createZodDto(invitationInfoResponseSchema) {
}
